import React from 'react'
import PropTypes from 'prop-types'
import SearchResultBookItem from '@components/SearchResultList/SearchResultBookItem'
import SearchResultSectionItem from './SearchResultSectionItem'

const SearchResultList = (props) => {
  const { results, isStudent } = props

  return results?.map((result, index) => {
    const { __typename: typename } = result

    switch (typename) {
      case 'Book':
        return <SearchResultBookItem key={index} book={result} isStudent={isStudent} />

      case 'Section':
        return <SearchResultSectionItem key={index} section={result} />
    }
  })
}

SearchResultList.propTypes = {
  onChange: PropTypes.func,
}

export default SearchResultList
